module.exports = __webpack_public_path__ + "img/explorer_logo_white.bb603037.png";